/**
 * Request-access spec §8.4: the member list speaks the approve control's vocabulary. Label only — there is no
 * permission picker in v1. Anything else (an unexpected value) is shown as stored.
 */
export const permissionLabel = (permission: string) =>
  permission === 'WRITE' ? 'Can edit' : permission === 'READ' ? 'Can view' : permission
